import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import ActionItem from "../../Global/ActionItem";
import { toast } from "react-toastify";
import { DepartmentRecord } from "../../../type/departmentRecord";
import WarningRedAlert from "../../ErrorAndAlert/WarningRedAlert";
import { Link } from "react-router-dom";
import { defaultLang, secondLang } from "../../../utils";

const DepartmentTableItem: React.FC<{
  department: DepartmentRecord;
  fetchData: () => void;
  lastIndex: number;
}> = ({ department, fetchData: propFetchData, lastIndex }) => {
  const { i18n, t } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);

  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/departments/${department.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.The record deleted successfully")}`,
    true,
    true
  );
  useEffect(() => {
    if (deleteR) {
      isShowDelete(false);
      propFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (department.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(
        t(
          "Message.You cannot delete the department. It's either used in planting or workshop or belongs to a municipality or community."
        )
      );
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };
  const active =
    i18n.language === secondLang
      ? department.is_active_transes[secondLang]
      : department.is_active_transes[defaultLang];
  return (
    <Fragment>
      <TableCell align="left">{department.project_country}</TableCell>
      <TableCell>
        <Link
          className="hover:text-ph-hover"
          to={`/setting/departments/view-department/${department.slug}`}
        >
          {department.name}
        </Link>
      </TableCell>
      <TableCell>
        <p
          className={`${
            department.is_active_transes[secondLang] === "Active"
              ? "bg-ph-toggle-bg-green text-ph-toggle-text-green"
              : "bg-ph-toggle-bg-red text-ph-red-warning"
          } text-center w-16 py-1 rounded-xl`}
        >
          {active}
        </p>
      </TableCell>

      <TableCell align="right">
        <ActionItem
          delete={true}
          editLink={`/setting/departments/edit-department/${department.slug}`}
          deleteAction={deleteAction}
          view=""
          viewLink={`/setting/departments/view-department/${department.slug}`}
          viewDepartment={t("Department.View") + ""}
          historyLink=""
          viewHistory=""
          width="w-[98px]"
        />
      </TableCell>
      {showDelete && (
        <WarningRedAlert
          type={t("PlantingFilter.Department")}
          hide={hide}
          action={deleteItem}
          isDelete={true}
          isSignOut={false}
        />
      )}
    </Fragment>
  );
};

export default DepartmentTableItem;
